import React from 'react'
import {AppBar, Box, Dialog, DialogContent, IconButton, Toolbar, Typography} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import {toDateTime} from '../../shared/functions/toDateTime';
import CloseIcon from '@material-ui/icons/Close';
import ShippedDetailsList from "./ShippedDetailsList";


const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        color: 'white'
    },
    createdAt: {
        color: 'white'
    },
    toolBar: {
        justifyContent: 'space-between'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const ShippedDetails = ({items, open = false, onClose}) => {
    const classes = useStyles()
    return (
        <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar className={classes.toolBar}>

                    <Typography variant="h6" className={classes.title}>
                        {"CONTAINER CODE : " + items.ContainerCode}
                    </Typography>

                    <Typography variant="h6" className={classes.createdAt}>
                        {"CREE LE : " + toDateTime(items.CreateAt.seconds).toLocaleString()}
                    </Typography>

                    <Box>
                        <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
                            <CloseIcon/>
                        </IconButton>

                    </Box>

                </Toolbar>
            </AppBar>

            <DialogContent>
                <ShippedDetailsList containerCode={items.ContainerCode}/>
            </DialogContent>
        </Dialog>
    )
}

export default ShippedDetails
